import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { calculatePolygonMeasurements } from '@tmapy/mapcore';
import { useMessage } from '@tmapy/intl';
import { SvgPolygon } from '@tmapy/style-guide';
import { SegmentMeasurement } from './SegmentMeasurement';
import { MeasurementHeader } from './MeasurementHeader';
import { measureMessages } from './measureMessages';
export const PolygonMeasurement = ({ feature, polygon, projection, dispatch, }) => {
    const formatMessage = useMessage();
    const measurements = calculatePolygonMeasurements(polygon, projection);
    return (_jsxs(_Fragment, { children: [_jsx(MeasurementHeader, { icon: _jsx(SvgPolygon, {}), label: formatMessage(measureMessages.measureArea), value: `${measurements.totalArea.valueFormat} ${measurements.totalArea.units}`, feature: feature, projection: projection, dispatch: dispatch }), measurements.mapSegments.map((mapSegment, index) => (_jsx(SegmentMeasurement, { segments: mapSegment }, index)))] }));
};
//# sourceMappingURL=PolygonMeasurement.js.map